import type { RouteLocationNormalizedGeneric } from 'vue-router';
import type { SwitchState } from '#layers/runtime/public';

export function isGuestOrPublicRoute(to: { meta?: { middleware?: unknown } }) {
	if (!to.meta?.middleware || !Array.isArray(to.meta.middleware)) return false;
	return to.meta.middleware.some(
		(m: unknown) => typeof m === 'string' && (m === 'guest' || m === 'public'),
	);
}

export function isWorkspaceRoute(route: Pick<RouteLocationNormalizedGeneric, 'matched'>) {
	return route.matched.some((m) => m.name === 'workspace-base');
}

/**
 * Routes that still consume the active workspace runtime while temporarily living outside its URL namespace
 * opt in via `definePageMeta({ keepsWorkspaceRuntime: true })`.
 * `/~/no-workspace` and `/~/workspaces/create` are excluded on purpose: they render system-only content
 * that asserts no usable workspace, so a lingering runtime there would be stale.
 */
export function keepsWorkspaceRuntime(route: Pick<RouteLocationNormalizedGeneric, 'matched'>) {
	return isWorkspaceRoute(route) || route.matched.some((m) => m.meta.keepsWorkspaceRuntime === true);
}

/**
 * Whether the workspace silhouette must replace routed content: while a candidate prepares or publishes, and on
 * any workspace route whose runtime is absent or mismatched until Vue Router and workspace publication agree again.
 */
export function showsWorkspaceShell({ phase, routeWorkspace, runtimeSlug }: { phase: SwitchState<unknown>['phase']; routeWorkspace: unknown; runtimeSlug: string | null }) {
	if (phase === 'preparing' || phase === 'publishing') return true;
	return typeof routeWorkspace === 'string' && routeWorkspace !== runtimeSlug;
}
